import React, { FC } from 'react'

import styled from 'styled-components'

import { RequireOne } from 'src/types'

import { Txt, FontSizeType } from './Txt'

type Props = {
  maxLineLimit: number // 最大行数
  sizeType?: FontSizeType
  className?: string
} & ChildrenType

// text or children どちらは必須
type ChildrenType = RequireOne<{
  text?: string
  children?: React.ReactNode
}>

const StyledTxt = styled(Txt)<{ maxLineLimit: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${({ maxLineLimit }) => maxLineLimit};
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
`

/** 指定した行数を超える文字は...を表示する */
export const LineLimitTxt: FC<Props> = ({ text, maxLineLimit, sizeType, children, className }) => {
  const item = children ?? text

  return (
    <StyledTxt maxLineLimit={maxLineLimit} sizeType={sizeType} className={className}>
      {item}
    </StyledTxt>
  )
}
